import { CamelCaseKeys } from '@utils/typescript';
import { InsuranceTypes } from '@models/InsuranceType';
import { tEnum } from '../components/i18n';

export enum BillingTypes {
  Reimbursement = 'reimbursement',
  DirectBilling = 'direct_billing'
}

export enum BillingTypeCodes {
  Reimbursement = 'RI',
  DirectBilling = 'DB'
}

export const BillingTypeCodeToTypeMapping = {
  [BillingTypeCodes.Reimbursement]: BillingTypes.Reimbursement,
  [BillingTypeCodes.DirectBilling]: BillingTypes.DirectBilling,
};

export enum ClaimStatuses {
  Requested = 'requested',
  Submitted = 'submitted',
  Reviewing = 'reviewing',
  Voided = 'voided',
  Nonpayable = 'non_payable',
  Paid = 'paid',
}

export enum ClaimableTypes {
  Car = 'CarClaim',
  PersonalAccident = 'PersonalAccidentClaim',
  Cancer = 'CancerClaim',
  CorporateHealth = 'CorporateHealthClaim',
  Health = 'HealthClaim',
}

export type ClaimList = CamelCaseKeys<{
  id: number;
  claimable_id: number;
  claimable_type: ClaimableTypes;
  insurance_type: InsuranceTypes;
  order_number: string;
  policy_number: string;
  claim_number: string;
  status: ClaimStatuses;
  billing_type_code: string;
  created_at: number;
}>;

export type Claim = ClaimList &
CamelCaseKeys<{
  note: string;
  total_claimed_amount: number;
  approved_amount: number;
}>;

const CLAIM_STATUSES_VARIANTS_MAPPING = {
  [ClaimStatuses.Requested]: 'info',
  [ClaimStatuses.Submitted]: 'secondary',
  [ClaimStatuses.Reviewing]: 'primary',
  [ClaimStatuses.Voided]: 'dark',
  [ClaimStatuses.Nonpayable]: 'danger',
  [ClaimStatuses.Paid]: 'success',
};

export const getClaimStatusVariant = (status: ClaimStatuses) => {
  return CLAIM_STATUSES_VARIANTS_MAPPING[status];
};

export const tClaimStatus = (status: ClaimStatuses) => tEnum('claimStatuses', status);
